import { positionApi } from '@/entities/Position';
import { fetchAllPages } from '@/shared/lib';

export interface PositionDepartmentOption {
  id: string | number;
  name: string;
}

export async function fetchDepartmentPositionOptions(
  departmentId: number
): Promise<PositionDepartmentOption[]> {
  try {
    const result = await fetchAllPages((page) =>
      positionApi.searchPositions({ departmentId, active: true, page })
    );
    return result.map((p) => ({
      id: p.id,
      name: p.name,
    }));
  } catch {
    return [];
  }
}
